import { z } from 'zod';
import { IsoDateTime, Uuid } from './common';

/** Placeholders the message templates understand ("Inserir:" chips). */
export const TEMPLATE_PLACEHOLDERS = [
  'cliente',
  'produto',
  'preco_unitario',
  'quantidade',
  'total',
  'prazo',
  'validade',
  'rastreio',
  'numero_pedido',
] as const;
export type TemplatePlaceholder = (typeof TEMPLATE_PLACEHOLDERS)[number];

/** Replaces `{name}` with values; placeholders without a value stay as typed. */
export function renderTemplate(body: string, values: Partial<Record<string, string>>): string {
  return body.replace(/\{([a-z_]+)\}/g, (match, key: string) => values[key] ?? match);
}

export const MessageTemplate = z
  .object({
    id: Uuid,
    name: z.string(),
    body: z.string(),
    sort: z.number().int(),
    updatedAt: IsoDateTime,
  })
  .meta({ id: 'MessageTemplate' });
export type MessageTemplate = z.infer<typeof MessageTemplate>;

export const MessageTemplateList = z.object({ data: z.array(MessageTemplate) });

export const CreateMessageTemplateBody = z.object({
  name: z.string().trim().min(1).max(120),
  body: z.string().trim().min(1).max(4000),
  sort: z.number().int().min(0).max(10_000).optional(),
});
export const UpdateMessageTemplateBody = CreateMessageTemplateBody.partial();
